export const programsBaseUrl = '/api/v1/program';

export const programsApi = `${programsBaseUrl}/all/`;

export const myProgramsApi = `${programsBaseUrl}/all/my/`;

export const favoriteProgramsApi = `${programsBaseUrl}/favorite/`;
